import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  setCapacityPlaningCollaboratorTab
} from "Actions";

import CapacityPlaningCollaborator from "./CapacityPlaningCollaborator";
import { fetchNonCategorizedTaskTypeCount } from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { isManagerAccess, isAdminAccess, isSuperAdminAccess } from "Utils";
import { getURLParams } from "../../utils";
import { selectLoggedAs } from "Selectors";
import moment from "moment";

class CapacityPlaningCollaboratorPage extends PureComponent {
  collaboratorId;
  tab;
  constructor(props) {
    super(props);
    let { id, tab } = this.props.match.params;
    let { name, uid } = this.props.match.params;
    this.collaboratorId = id;
    this.collaboratorName = name;
    this.tab = tab;
    this.uid = uid;
    this.year = getURLParams(props.location, "year").teamCalendarYear;
  }

  componentDidMount() {
    const { dispatch, subMenuDirection, capacityPlaningTab } = this.props;

    dispatch(setCurrentNavPage("CAPACITY_PLANING_PROD_PAGE"));
    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));
    dispatch(fetchNonCategorizedTaskTypeCount());

    capacityPlaningTab === null &&
      dispatch(setCapacityPlaningCollaboratorTab(this.tab));
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
  }

  render() {
    const { loggedAs, spaceAs } = this.props;

    if (
      (isManagerAccess(loggedAs, spaceAs) ||
        isAdminAccess(loggedAs, spaceAs) ||
        isSuperAdminAccess(loggedAs, spaceAs)) &&
      !this.collaboratorId
    ) {
      return <NotFoundV2 errorPageType={"ERROR_404"} />;
    }

    return (
      <div className={`page-content`}>
        <CapacityPlaningCollaborator
          collaboratorId={this.collaboratorId}
          date={
            new moment(
              this.year == new moment().year()
                ? new moment()
                : this.year + "-12-31"
            )
          }
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  subMenuDirection: state.params.subMenuDirection,
  collaborator: state.capacityPlaning.collaborator.collaborator,
  capacityPlaningTab: state.capacityPlaning.collaborator.tab,
  user: state.auth.user,
  loggedAs: selectLoggedAs(state)
});

export default connect(mapStateToProps)(CapacityPlaningCollaboratorPage);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningCollaboratorPage.js